<template>
    <el-dialog :visible.sync="visible" :title="!dataForm.id ? $t('add') : $t('update')" :close-on-click-modal="false"
               :close-on-press-escape="false">
        <div>
            <el-steps :active="active" finish-status="success">
                <el-step title="转账用户">
                </el-step>
                <el-step title="核对转账信息" description="步骤完成">
                </el-step>
            </el-steps>
        </div>
        <el-form :model="dataForm" :rules="dataRule" ref="dataForm" @keyup.enter.native="dataFormSubmitHandle()"
                 :label-width="$i18n.locale === 'en-US' ? '120px' : '80px'">
                 <el-form-item label="会员手机账户:" prop="memberMobile">
                     <el-input v-model="dataForm.memberMobile" :readonly="true" placeholder="会员手机号码"></el-input>
                 </el-form-item>
                 <el-form-item label="会员名称:" prop="memberName">
                     <el-input v-model="dataForm.memberName" :readonly="true" placeholder="会员名称"></el-input>
                 </el-form-item>
                 <el-form-item label="账户类型:" prop="balanceType">
                     <el-select v-model="dataForm.balanceType" placeholder="账户类型" @change="handleBalanceTypeChange">
                        <el-option
                                v-for="item in balanceTypes"
                                :key="item.value"
                                :label="item.label"
                                :value="item.value">
                        </el-option>
                     </el-select>
                 </el-form-item>
                 <el-form-item label="会员余额:" prop="cashBalance">
                     <el-input v-model="dataForm.cashBalance" :readonly="true" placeholder="会员账号余额"></el-input>
                 </el-form-item>
                 <el-form-item label="转帐手机号码" prop="transferMobile">
                     <el-input v-model="dataForm.transferMobile" :readonly="viewStatus" placeholder="转账手机号码"></el-input>
                 </el-form-item>
                 <el-form-item label="转账金额" prop="amount">
                     <el-input-number v-model="dataForm.amount" :disabled="viewStatus"  placeholder="转账金额"></el-input-number>
                 </el-form-item>
        </el-form>

        <template slot="footer">
            <el-button @click="visible = false">{{ $t('cancel') }}</el-button>
            <el-button style="margin-top: 12px;" v-if="active==1" @click="pre">上一步</el-button>
            <el-button style="margin-top: 12px;" v-if="active==0" @click="next">下一步</el-button>
            <el-button type="primary" v-if="active==1" @click="dataFormSubmitHandle()">{{ $t('confirm') }}</el-button>
        </template>
    </el-dialog>
</template>

<script>
    import debounce from "lodash/debounce"
    export default {
        data() {
            return {
                visible: false,
                active:0,
                viewStatus:false,
                balanceTypes: [{
                    value: 1,
                    label: '现金'
                },
                { 
                    value: 2,
                    label: '普通优果'
                },
                { 
                    value: 6,
                    label: '分享时长'
                },
                { 
                    value: 7,
                    label: '租金分红'
                },
                { 
                    value: 8,
                    label: '现金分红'
                },
                { 
                    value: 9,
                    label: '期权'
                }
                ],
                dataForm: {
                    memberId: '',
                    memberName:'',
                    memberMobile:'',
                    cashBalance:'',
                    balanceType: 1,
                    memberBalance:0,
                    transferMobile: '',
                    transferMemberName:'',
                    transferMemberId:0,
                    amount:0
                }
            }
        },
        computed: {
            dataRule() {
                return {
                    memberId: [
                        {required: true, message: this.$t('validate.required'), trigger: 'blur'}
                    ],
                    transferMobile: [
                        {required: true, message: this.$t('validate.required'), trigger: 'blur'}
                    ],
                    amount: [
                        {required: true, message: this.$t('validate.required'), trigger: 'blur'}
                    ]
                }
            }
        },
        methods: {
            init(id) {
                this.visible = true
                this.active=0
                this.viewStatus=false;
                this.$nextTick(() => {
                    this.$refs['dataForm'].resetFields()

                    this.dataForm.id=id;
                    this.getMemberInfo();
                    this.getBalance();
                })
            },
            // 获取信息
            getMemberInfo() {
                this.$http.get(`/ums/memberbalance/${this.dataForm.id}`).then(({data: res}) => {
                    if (res.code !== 0) {
                        return this.$message.error(res.msg)
                    }
                    this.dataForm.memberId=res.data.memberId;
                    this.dataForm.memberName=res.data.memberName;
                    //this.dataForm.cashBalance=res.data.cashBalance;
                    this.dataForm.memberMobile=res.data.mobileNumber;
                }).catch(() => {
                })
            },
            getBalance() {
                this.$http.get(`/ums/memberbalance/getByBalance/${this.dataForm.id}`).then(({data: res}) => { 
                   if(this.dataForm.balanceType!=null && this.dataForm.balanceType==1) {
                    this.dataForm.cashBalance=res.data.cashBalance
                   }else if(this.dataForm.balanceType!=null && this.dataForm.balanceType==2) {
                    this.dataForm.cashBalance=res.data.integrationBalance
                   }else if(this.dataForm.balanceType!=null && this.dataForm.balanceType==6) {
                    this.dataForm.cashBalance=res.data.integrationShare
                   }else if(this.dataForm.balanceType!=null && this.dataForm.balanceType==7) {
                    this.dataForm.cashBalance=res.data.diskRentBalance
                   }else if(this.dataForm.balanceType!=null && this.dataForm.balanceType==8) {
                    this.dataForm.cashBalance=res.data.cashShare
                   }else if(this.dataForm.balanceType!=null && this.dataForm.balanceType==9) {
                    this.dataForm.cashBalance=res.data.stockBalance
                   }else {
                    this.dataForm.cashBalance=0

                   }
                }).catch(() => {
                })
            },
            // Handle balance type change
            handleBalanceTypeChange(value) {
                this.getBalance();
            },
            // 获取信息
            getTransferMemberInfo(mobile) {
                this.$http.get(`/pms/umsmember/getByMobile/`+mobile).then(({data: res}) => {
                    if (res.code !== 0) {
                        return this.$message.error(res.msg)
                    }

                    this.dataForm.transferMemberName=res.data.name;
                    this.dataForm.transferMobile=res.data.mobile;
                    this.dataForm.transferMemberId=res.data.id;
                    if(this.dataForm.transferMemberId==null || this.dataForm.transferMemberId<=0) {
                        return this.$message.error("不存在该手机号码的会员账号")
                    }
                    if(this.active<1) {
                        this.active++;
                    }
                    if(this.active==1) {
                        this.viewStatus=true;
                    }
                }).catch(() => {

                })
            },
            pre(){
                if(this.active>0) {
                    this.active--;
                }
                this.viewStatus=false;

            },
            next(){
                this.$refs['dataForm'].validate((valid) => {
                    if (!valid) {
                        return false
                    }
                    if(this.dataForm.amount<=0) {
                        return this.$message.error("转账金额大于0")
                    }
                    if(this.dataForm.balanceType<=0 || this.dataForm.balanceType==null) {
                        return this.$message.error("请选择转账类型")
                    }
                    if(this.dataForm.memberMobile==this.dataForm.transferMobile){
                        return this.$message.error("不能转账同一个账户")
                    }
                    this.dataForm.transferMemberId=0;
                    this.dataForm.transferMemberName="";
                    console.log(this.dataForm.transferMobile);
                    this.getTransferMemberInfo(this.dataForm.transferMobile);
                }, 1000, {'leading': true, 'trailing': false})

            },
            // 表单提交
            dataFormSubmitHandle: debounce(function() {
                console.log(this.dataForm.transferMobile);
                this.$refs['dataForm'].validate((valid) => {
                    if (!valid) {
                        return false
                    }
                    this.$http['put']('/ums/memberbalance/difMemberTransfer', this.dataForm).then(({data: res}) => {
                        if (res.code !== 0) {
                            return this.$message.error(res.msg)
                        }
                        this.$message({
                            message: this.$t('prompt.success'),
                            type: 'success',
                            duration: 500,
                            onClose: () => {
                                this.visible = false
                                this.$emit('refreshDataList')
                            }
                        })
                    }).catch(() => {
                    })
                })
            }, 1000, {'leading': true, 'trailing': false})
        }
    }
</script>